<template>
  <div class="content-box">
    <HconMyPageUsrInfo />
    <div class="sub-wrapper">
      <HconMyPageSideMenu />
      <div class="sub-contents">
        <div class="border-title title">
          <p class="title">핀발행 요청 관리<span class="desc">핀발행 요청 내역과 진행 상태를 확인하실 수 있습니다.</span></p>
        </div>
        <div class="box-gray mt28 search">
          <fieldset class="search-form-wrap">
            <legend>핀발행 요청 검색 폼</legend>
            <div class="search-form">
              <div class="form-box">
                <div class="form-group row">
                  <HconMonthDate label="요청일자" v-model="qryDates" />
                </div>
              </div>
              <div class="form-box">
                <!--   -->
                <div class="form-group row"> 
                  <HconDropDown type="dropdownBox" label="진행상태" :hide-label="false" defaultLabel="전체" placeholder="전체" v-model="inputValues.qryPrgrStCd" :dropdownOptions="dropDownPinOrdSt" selectBoxTitleClass="w300" :has-tooltip="true" tooltipClass="tooltip-left ta-l">
                    <template v-slot:tooltipContent>
                      <strong class="font-bold">진행상태 안내</strong>
                      <span class="tooltip-list">
                        <em>1. 요청 : 핀발행 요청이 접수된 상태입니다.</em>
                        <em>2. 검토 : 담당자가 요청 내용을 확인 중입니다.</em>
                        <em>3. 심사완료
                          <span class="inner-list">
                            <em>1) 승인 : 핀발행이 승인되어 결제 대기 상태입니다.</em>
                            <em>2) 반려: 요청 내용이 기준에 부합하지 않아 발행이 불가합니다.</em>
                            <em>3) 기간만료: 승인 후 14일 이내 결제 미진행으로 기간만료 처리되었습니다.</em>
                          </span>
                        </em>
                        <em>4. 주문완료
                          <span class="inner-list">
                            <em>결제가 완료되어 핀이 발행되었으며, 다운로드가 가능합니다.</em>
                            <em>(요청 건수에 따라 핀발행까지 최대 1시간 소요될 수 있습니다.)</em>
                          </span>
                        </em>
                      </span>
                    </template>
                  </HconDropDown>
                </div>
              </div>
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="dropdownBox" label="검색어" :hide-label="false" defaultLabel="검색어" placeholder="검색어" v-model="inputValues.qrySrchKey" :dropdownOptions="dropDownKeyword" selectBoxTitleClass="w300" />
                  <HconInput type="text" inputClass="ml20" :maxlength="dynamicLimit" :placeholder="srchValuePlaceHolder" v-model="inputValues.qrySrchValue" @buttonClick="getPinPblcList" @update:modelValue="handleNumberOnly"/>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button type="button" class="btn lg" @click="clickSearchButton">조회</button>
            </div>
          </fieldset>
        </div>
        <div class="contents-title-wrap mt40 button">
          <div class="contents-title">
            <h4 class="font-bold">총 <span class="text-green">{{ totalData }}</span>건</h4>
          </div>
          <div class="rgt-area">
            <HconDropDown type="dropdownBox" :hide-label="true" defaultLabel="20개씩 보기" v-model="stringRowPerPage" 
                            :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" />
          </div>
        </div>
        <div class="contents-detail-wrap">
          <table class="tbl-type">
            <caption>최근 구매내역</caption>
            <colgroup>
              <col style="width: 20%;">
              <col style="width: auto;">
              <col style="width: 12%;">
              <col style="width: 10%;">
              <col style="width: 13%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">요청번호/요청일시</th>
                <th scope="col">주문명/상품명</th>
                <th scope="col">요청수량</th>
                <th scope="col">진행상태</th>
                <th scope="col">승인일</th>
              </tr>
            </thead>
            <tbody v-if="pinPblcList.length > 0">
              <tr v-for="(request, index) in pinPblcList" :key="index">
                <td>
                  <div class="order-number">
                    <NuxtLink :to="`/pc/mypage/pin-publication-request/detail/${request.pblcReqNo}`" class="link-underline">
                      <p>{{ request.pblcReqNo }}</p>
                      <span>{{ request.requestDate }}</span>
                    </NuxtLink>
                  </div>
                </td>
                <td>
                  <div class="product-box">
                    <div class="product-info">
                      <NuxtLink :to="`/pc/mypage/pin-publication-request/detail/${request.pblcReqNo}`" class="link-underline">
                        <p class="title01">{{ request.requestTitle }}</p>
                        <p class="desc01">{{ request.requestDetail }}</p>
                      </NuxtLink>
                    </div>
                  </div>
                </td>
                <td>{{ request.count }}</td>
                <td>{{ request.requestType }}</td>
                <td><p class="desc01">{{ request.passDate }}</p></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="nodata">요청 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
          <HconPagnation v-if="isPagNavi" :max-page="totalPage" :current-page="currentPage" @update:currentPage="handlePagination" />
        </div>
      </div>
    </div> 
  </div>
</template>
<script lang="ts" setup>
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconPagnation from '@/components/com/HconComPCPagination.vue'
import HconMonthDate from '@/components/com/HconComPCDateButton.vue'
import moment from 'moment-timezone';

import { ref, computed } from 'vue';
import { COMMON_CODE } from "@/constants/hconMessageConstants";
import type { MypagePinPblcSearchResDto } from '@/types/mypage/backend-dto-types';

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

const fetchBuilder  = useHconFetchBuilder() // API 호출 준비
const { showAlert } = usePopup()
const pinPblcList = ref<any[]>([]) // 목록

// 화면 마운트
onMounted(() => {
  getPinPblcList()
})

// 드롭다운 그리기 
const dropDownPinOrdSt = [ // 핀발행 주문상태
    {key: '', value: '전체'}
  , {key: '10', value: '요청'}
  , {key: '20', value: '검토'}
  , {key: '30', value: '승인'}
  , {key: '90', value: '반려'}
  , {key: '40', value: '기간만료'}
  , {key: '50', value: '주문완료'}
]
const dropDownKeyword = [ // 키워드(검색어)
    {key: '', value: '검색어'}
  , {key: 'pblcReqNo', value: '발행요청번호'}
  , {key: 'ordNm', value: '주문명'}
  , {key: 'gdsNm', value: '상품명'}
]
const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
]

// 숫자만 입력 체크
const handleNumberOnly = async (val: any) => {
  
  if(inputValues.value.qrySrchKey !== 'pblcReqNo') {
    return 
  }

  if(val === undefined || val === null) {
    return 
  }

  // 숫자입력 검증(처음 시작 0, 문자입력 -> X)
  let filtered = String(val).replace(/\D/g, '').replace(/^0+/, '')

  if(inputValues.value.qrySrchValue !== filtered) {
    await nextTick()
    inputValues.value.qrySrchValue = filtered
  } else {
    await nextTick()
    inputValues.value.qrySrchValue = ''
    await nextTick()
    inputValues.value.qrySrchValue = filtered
  }
}

// input MaxLength 제어
const dynamicLimit = computed(() => {
  if(inputValues.value.qrySrchKey === 'pblcReqNo') {
    inputValues.value.qrySrchValue = ''
  }
  return inputValues.value.qrySrchKey !== 'pblcReqNo' ? 30 : 10
})


//////////////////////////////////////////////
// 핀발행 요청관리 목록 조회
//////////////////////////////////////////////

// 검색어 플레이스홀더 변경 함수
const srchValuePlaceHolder = computed(() => {
  const defaultPH = '검색어를 선택하세요'
  const currentKey = inputValues.value.qrySrchKey;
  const foundItem = dropDownKeyword.find(item => item.key === currentKey);
  if (!foundItem) return defaultPH;
  // 받침에 따른 조사처리는 유니코드 검색하지 않고 하드코딩함.
  const label = foundItem.value;
  if (label === '요청번호') return `${label}로 검색해주세요`;
  if (label === '주문명' || label === '상품명') return `${label}으로 검색해주세요`;
})

// 1. 페이지네이션 매핑대상 변수 준비
const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20); // 페이징 건수
const totalData   = ref<number>(0);  // 총 데이터 건수
const isPagNavi = computed (() => { // 페이징 노출 관련
  return totalPage.value === 0 ? false : true
})
const totalPage = computed (() => {  // 총 페이지 건수(계산식)
  if(pinPblcList.value.length === 0) return 0;
  return Math.ceil(totalData.value / rowPerPage.value);
});

// 2. 페이지네이션 클릭이벤트 핸들링 함수
const handlePagination = (pageNum: number) => {
  // 2.1. 숫자 클릭 시, 현재페이지를 새값으로 바꾸고 API호출
  currentPage.value = pageNum; 
  getPinPblcList();
}

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    getPinPblcList();
  }
})

// 추가기능2: 조회조건에 따른 (재)조회버튼이 있을 경우, 1페이지로 재설정 필요
const clickSearchButton = () => {
  currentPage.value = 1;
  getPinPblcList();
}

// 조회조건 입출력용 매핑대상 준비
const qryDates = ref<[Date, Date] | null>(null);
const inputValues = ref({
    qryPrgrStCd: ''     // 진행상태코드
  , qrySrchKey: ''      // 조회키 [pblcReqNo, ordNm, gdsNm]
  , qrySrchValue: ''    // 조회값 [발행요청번호, 주문명, 상품명]
})

// 조회조건 읽기전용 매핑대상 준비
const searchParams = computed(() => {
  const qryStartDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[0],'YYYYMMDD') : '';
  const qryEndDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[1],'YYYYMMDD') : '';
  return {
    ...inputValues.value
    , qryStrtDt: qryStartDate   // 조회시작일자
    , qryEndDt: qryEndDate      // 조회종료일자
    , pageNum: currentPage.value
    , pageSize: rowPerPage.value
  }
})

// 마이페이지 핀발행 주문내역 목록 조회
const getPinPblcList = async () => {
  if(await checkSearchAvailable()) {
    // API 호출
    const pinPblcListFetcher =
      fetchBuilder.get<TableDataInfo<MypagePinPblcSearchResDto>>('/api/v1/mypage/pin-publication/list')
      .query(searchParams.value)
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then((res) => {
        if(res.resultCode != '200') {
          showAlert({
            title: '알림',
            message: res.resultMessage,
            confirmText: '확인'
          })
        } else {
          const dataMap = res.data.map((item) => ({
            pblcReqNo: item.mgrApvSeq,
            requestDate: HconCommonUtils.format.dateTime(item.apvReqDtm),
            requestTitle: item.ordNm,
            requestDetail: item.gdsCnt > 1 ? item.gdsNm + ' 외 ' + (Number(item.gdsCnt) - 1) + '건' : item.gdsNm,
            count: HconCommonUtils.format.expComma(item.pinPblcReqAllGdsQty) + '건',
            requestType: dropDownPinOrdSt.find(target => target.key === item.hcApvStCd)?.value,
            passDate: item.athzCmptDtm === '' ? '' : moment(item.athzCmptDtm,'YYYYMMDD').format('YYYY-MM-DD')
          }))
          pinPblcList.value = dataMap

          totalData.value = res.total || 0; // 페이지네이션 처리
        }
    });
  }
}

// 검색조건 체크 함수
const checkSearchAvailable = async () => {
  
  // 검색어를 입력했는데, 드롭다운 미선택 시 false 반환
  if(searchParams.value.qrySrchValue !== '' && searchParams.value.qrySrchKey === '') {
    showAlert({
        title: '알림',
        message: COMMON_CODE.ALT_HCON_9177,
        confirmText: '확인'
      })
    return false;
  }

  if(searchParams.value.qrySrchKey === 'pblcReqNo') {
    
    if(searchParams.value.qrySrchValue === '' || searchParams.value.qrySrchValue.length === 0) {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9174),
        confirmText: '확인'
      })
      return false;
    }
  }

  return true;
}

</script>
<style lang="scss" scoped>
  @use "@/assets/scss/pc/mypage-hcon.scss" as *;
  @use "@/assets/scss/pc/order-hcon.scss" as *;
</style>